import React from 'react';
import RichTextBlockComponent, { type RichTextComponentProps } from 'content/RichText';

interface RichTextBlockProps {
    data: RichTextComponentProps;
}

const RichTextBlock: React.FC<RichTextBlockProps> = ({ data }) => <RichTextBlockComponent {...data} />;
export default RichTextBlock;
